import { useEffect, useRef } from 'react'
import { burstAtElement } from '@/components/ui/confetti/confettiBurst'

const BURST_THROTTLE_MS = 2000

const scoresEqual = (a, b) => {
  const keys = new Set([...Object.keys(a || {}), ...Object.keys(b || {})])
  for (const key of keys) {
    if (a?.[key] !== b?.[key]) return false
  }
  return true
}

/**
 * Fires a confetti burst when any tracked score value changes (e.g. live Pusher updates).
 * `scores` is a flat object of values to watch (regular, extra time, penalties, ...).
 * Skips the initial mount and throttles rapid updates.
 */
const useScoreChangeBurst = (anchorRef, { scores = {}, enabled = true } = {}) => {
  const prevScoresRef = useRef(null)
  const lastBurstAtRef = useRef(0)

  const serialized = JSON.stringify(scores)

  useEffect(() => {
    if (!enabled) return

    if (prevScoresRef.current == null) {
      prevScoresRef.current = scores
      return
    }

    if (scoresEqual(prevScoresRef.current, scores)) return

    prevScoresRef.current = scores

    const now = Date.now()
    if (now - lastBurstAtRef.current < BURST_THROTTLE_MS) return

    const element = anchorRef?.current
    if (!element) return

    lastBurstAtRef.current = now
    burstAtElement(element)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [anchorRef, serialized, enabled])
}

export default useScoreChangeBurst
